import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { AuthProvider } from './context/auth-context'
import { supabase } from './services/supabase'

export function App() {
  const [initChecked, setInitChecked] = useState(false)
  const [initError, setInitError] = useState<string | null>(null)

  useEffect(() => {
    // Check if Supabase is properly initialized
    const checkSupabaseInit = async () => {
      try {
        // Verify Supabase connection by checking session
        const { error } = await supabase.auth.getSession()

        if (error) {
          console.error('Error initializing Supabase:', error)
          setInitError(
            'Failed to connect to authentication service. Please try refreshing the page.'
          )
        } else {
          console.log('Supabase initialized successfully')
        }

        // Set initialization as complete
        setInitChecked(true)
      } catch (err) {
        console.error('Failed to initialize Supabase:', err)
        setInitError('An unexpected error occurred. Please try refreshing the page.')
        // Still mark as initialized to prevent hanging
        setInitChecked(true)
      }
    }

    checkSupabaseInit()
  }, [])

  // Don't render anything until initialization is complete
  if (!initChecked) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        <p className="ml-3 text-foreground">Initializing application...</p>
      </div>
    )
  }

  // Show error message if initialization failed
  if (initError) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-background">
        <div className="bg-red-900/20 border border-red-800 text-red-100 px-6 py-4 rounded-lg max-w-md">
          <h2 className="text-xl font-bold mb-2">Connection Error</h2>
          <p>{initError}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-primary text-white rounded hover:bg-primary/80"
          >
            Refresh Page
          </button>
        </div>
      </div>
    )
  }

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  )
}
